module.exports = __webpack_public_path__ + "static/media/hays.89ba1bcf.png";